var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list-item',{attrs:{"link":"","to":_vm.link},on:{"click":_vm.handleClick}},[(_vm.icon)?_c('v-list-item-icon',[_c('v-icon',{staticClass:"white--text"},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1):_vm._e(),(_vm.label)?_c('v-list-item-content',{staticClass:"white--text font"},[_vm._v(" "+_vm._s(_vm.label)+" ")]):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }